'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsDetail = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var newsDetail = exports.newsDetail = {
    template: require('./detail.html'),
    bindings: {
        newsdetail: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "$state", "common", "$scope", "gettextCatalog", "Analytics", function controller($rootScope, $state, common, $scope, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.mediaTotal = 0;
        vm.extractVideoId = extractVideoId;
        vm.$onChanges = bindingChanges;

        vm.sliderSettings = {
            autoplay: true,
            autoplaySpeed: 10000,
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 576,
                settings: {
                    dots: true,
                    arrows: false
                }
            }],
            event: {
                beforeChange: function beforeChange(event, slick, currentSlide, nextSlide) {
                    slick.$slider.toggleClass('slick-slider-light', angular.element(slick.$slides[nextSlide]).find('.hero').hasClass('hero-light'));
                }
            }
        };

        function init() {

            common.setTitle(vm.newsdetail.title);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/news/' + vm.newsdetail.id, vm.newsdetail.title);

            //if there is no previous state go back news
            $state.previous.name === '' ? $state.previous.name = 'news' : $state.previous.name;
            //set the previous breadcrumb
            vm.breadcrumbPrevious = $state.fromParams.breadcrumbName ? $state.fromParams.breadcrumbName : gettextCatalog.getString('News');

            //vm.newsdetail.videos
            vm.mediaTotal = vm.newsdetail.gallery.length;

            //getMediaSliderDescription(0);
        }

        function bindingChanges(changes) {
            if (changes.newsdetail) {
                if (changes.newsdetail.currentValue) {
                    vm.newsdetail = Object.assign(changes.newsdetail.currentValue, {
                        description: (0, _marked2.default)(changes.newsdetail.currentValue.description || '')
                    });
                } else {
                    vm.newsdetail = changes.newsdetail.currentValue;
                }
            }
        }

        vm.gallerySliderSettings = {
            autoplay: false,
            dots: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            enabled: true,
            infinite: false,
            variableWidth: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }],
            method: {}
        };

        function extractVideoId(videoUrl) {
            var video_id = videoUrl.replace('http://www.youtube.com/', '');
            return video_id;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/news/detail.js
// module id = 951
// module chunks = 0